import React, {useEffect, Fragment} from 'react';
import {autorun, computed} from 'mobx';
import Moment from 'moment';
import {observer} from 'mobx-react';
import {Route} from 'sulu-admin-bundle/services/Router';
import type {ViewProps} from 'sulu-admin-bundle/containers/ViewRenderer';
import type {Element, Node} from 'react';

type Props<T> = {
    ...ViewProps,
    children?: (T) => Element<*> | null,
    childrenProps: T,
    header?: Node,
    routeChildren?: Array<Route>,
    selectedIndex?: number,
    title?: string,
};


@observer
class ReportView<T> extends React.Component<Props<T>> {
    static defaultProps = {
        childrenProps: {},
    };

    redirectToRouteWithHighestPriorityDisposer: () => void;

    constructor(props: Props<T>) {
        super ( props );

        this.state = {
            leagueName: [],
        };

    }



    componentDidMount()
    {
        let href = window.location.href;
        let needle = href.indexOf('dhbmatch/') > 0 ? 'dhbmatch/' : 'dhbmatches/';
        let index = href.indexOf(needle);
        let temp = href.substr(index+needle.length+3);
        let index2 = temp.indexOf('/');

        const id = temp.substr(0,index2);
        const locale = 'de';

        let baseUrl = location.protocol + '//' + location.host;
        let endPointData = baseUrl + `/admin/api/dhbmatches/${id}?locale=${locale}`;



        const loadData = async () => {

            try {

                const requestForthumbId = await fetch(endPointData)
                const data = await requestForthumbId.json()

                console.log(data)

                const logoHomeId = data?.homeTeam?.logo?.id
                const logoId = data?.awayTeam?.logo?.id

                let endMediaPoint = baseUrl + `/admin/api/media/${logoId}?locale=${locale}`;

                let endMediaPointHome = baseUrl + `/admin/api/media/${logoHomeId}?locale=${locale}`;

                //console.log(endMediaPoint)

                const requestForthumb = await fetch(endMediaPoint)
                const resultrequestThumb = await requestForthumb.json()

                const requestForHomethumb = await fetch(endMediaPointHome)
                const resultrequestHomeThumb = await requestForHomethumb.json()



                this.setState({
                    leagueName: data.leagueName,
                    homeTeam: data.homeTeamName,
                    awayTeam: data.awayTeamName,
                    awayTeamLogo: resultrequestThumb?.thumbnails?.['image-150.webp'],
                    homeTeamLogo: resultrequestHomeThumb?.thumbnails?.['image-150.webp'],
                    matchDate: Moment(data.scheduleDate).format("D[.] MMMM YYYY"),
                    matchTime: data.scheduleTime,
                    status: data.status,
                    gameNum: data.id
                })

                console.log(endMediaPoint)

                //console.log(resultrequestThumb)
            } catch(error) {
                console.log(error)
            }

        }

        loadData();

    }


    render()
    {
        const {children, childrenProps, header, router, route, selectedIndex, title, isRootView} = this.props;

        const childComponent = children ? children(childrenProps) : null;

        return (
            <Fragment>
                <p>sfddsfdss</p>
                {header}
                {childComponent}
            </Fragment>
        );
    }
}


export default ReportView;